import { AuditoriaTab } from '@/features/auditoria';
import { AuditNavigation } from '@/features/auditoria/AuditNavigation';

export default function Auditoria() {
  return <><AuditNavigation /><AuditoriaTab /></>;
}
